import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'news-list',
  name: '图文资讯',
  icon: '讯',
  group: '校友会组件',
  description: '展示校友新闻、校园动态和公告。',
  defaultProps: {
    title: '校友资讯',
    limit: 4
}
}
